import axios from 'axios';
import getConfig from 'next/config';
import { getKeycloakInstance } from '@react-keycloak-fork/ssr';
import persistor from '../utils/persistor';

const { publicRuntimeConfig } = getConfig();
const anonymousRequest = axios.create({ baseURL: publicRuntimeConfig.apiUrl });
const request = axios.create({ baseURL: publicRuntimeConfig.apiUrl });

request.interceptors.request.use(async config => {
    const { token } = persistor.getTokens();
    config.headers.Authorization = `Bearer ${token}`; // eslint-disable-line no-param-reassign
    return config;
});

// this creates a user and logs the user in

export async function createUser(firstName, lastName, email, password, affiliate) {
    const {
        data: { tokens },
    } = await anonymousRequest.post('/user', { firstName, lastName, email, password, affiliate });

    persistor.setInitialLoginFlow();
    persistor.setTokens({ token: tokens.id_token, refreshToken: tokens.refresh_token });

    const keycloak = getKeycloakInstance();
    const timeLocal = new Date().getTime();

    keycloak.silentCheckSsoRedirectUri = false;

    keycloak.token = tokens.access_token;
    keycloak.tokenParsed = decodeToken(keycloak.token);
    keycloak.idToken = tokens.id_token;
    keycloak.idTokenParsed = decodeToken(keycloak.idToken);
    keycloak.refreshToken = tokens.refresh_token;
    keycloak.refreshTokenParsed = decodeToken(keycloak.refreshToken);

    keycloak.timeSkew = Math.floor(timeLocal / 1000) - keycloak.tokenParsed.iat;

    keycloak.checkLoginIframe = false;
    keycloak.redirectUri = origin;

    keycloak.onAuthSuccess();

    keycloak.authenticated = true; // this is done after the onAuthSuccess-hook to avoid a rerender
}

/* eslint-disable */
// code from keycloak-js
function decodeToken(str) {
    str = str.split('.')[1];

    str = str.replace(/-/g, '+');
    str = str.replace(/_/g, '/');
    switch (str.length % 4) {
        case 0:
            break;
        case 2:
            str += '==';
            break;
        case 3:
            str += '=';
            break;
        default:
            throw 'Invalid token';
    }

    str = decodeURIComponent(escape(atob(str)));

    str = JSON.parse(str);
    return str;
}
/* eslint-enable */

export async function getUser() {
    const { data } = await request.get('/user');

    return data.user;
}

export async function updateUser(user) {
    const { data } = await request.put('/user', { user });
    return data.user;
}

export async function updateUserData(type, data) {
    const { data: { user } } = await request.put(`/user/data/${type}`, { data });
    return user;
}

export function deleteUser() {
    const userId = getKeycloakInstance().subject;
    return request.delete('/user', { params: { confirm: true, userId } });
}

export async function verifyEmail(emailVerificationCode) {
    try {
        await anonymousRequest.post('/user/verify', { emailVerificationCode });
    } catch (error) {
        if (error.response.status === 404) return false;
        throw error;
    }
    return true;
}

export async function retryEmailVerification() {
    await request.post('/user/verify', { retry: true });
}

export async function updateUserAffiliation(affiliationId, data) {
    const {
        data: { user },
    } = await request.put(`/user/affiliations/${affiliationId}`, data);
    return user;
}

export async function removeUserAffiliation(affiliationId) {
    const {
        data: { user },
    } = await request.delete(`/user/affiliations/${affiliationId}`);
    return user;
}

export async function updateUserPreferences(preferenceType, preference) {
    const {
        data: { user },
    } = await request.put(`/user/preferences/${preferenceType}`, preference, { headers: { 'Content-Type': 'application/json' } });
    return user;
}
export async function inviteUserToKreditdata({ redirectUrl, flow } = { }) {
    if (!redirectUrl) redirectUrl = window.location.href; // eslint-disable-line no-param-reassign
    const { data } = await request.post(`/user/integrations/kreditdata/${flow}`, { redirectUrl });
    return data.kreditDataCustomerId;
}
export async function invitePartnerToKreditdata({ redirectUrl, flow, partnerEmail } = { }) {
    const { data } = await request.post(`/user/integrations/kreditdata/partner/${flow}`, { redirectUrl, partnerEmail });
    return data.link;
}
export async function fetchKreditdata({ id }) {
    const { data } = await request.get(`/user/integrations/kreditdata/${id}`);
    return data;
}
export async function fetchPartnerKreditdata({ id, userId }) {
    const { data } = await request.post(`/user/integrations/kreditdata/${id}/partner/${userId}/savepdf`);
    return data;
}
export async function saveKreditdataPensionPdf({ id }) {
    const { data } = await request.post(`/user/integrations/kreditdata/${id}/savepdf`);
    return data;
}
export async function saveKreditdataBudgetPdf({ id }) {
    const { data } = await request.post(`/user/integrations/kreditdata/${id}/saveBudgetPdf`);
    return data;
}
export async function getPensionAnalysis() {
    const { data } = await request.post('/user/analyse/pension');
    return data.analysis;
}

export async function uploadFile(file) {
    const formData = new FormData();
    formData.append('json', JSON.stringify({ fileType: file.type }));
    formData.append('file', file.file);
    const { data } = await request({ method: 'POST', url: '/user/files', data: formData });
    return data.file;
}

export async function deleteFile(fileId) {
    await request({ method: 'DELETE', url: `/user/files/${fileId}` });
    return fileId;
}
export async function getFileBinary(fileId) {
    const response = await request({
        url: `/user/files/${fileId}/binary`,
        responseType: 'blob',
    });
    return response.data;
}
